
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transfers/accept",
      function () {
        return require("private-next-pages/transfers/accept/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transfers/accept"])
      });
    }
  